import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenBulkStorage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 50,
	viewBox: "0 0 100.0 50.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 10.0 50.0 L 50.0 0.0 L 90.0 50.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 50.0 L 100.0 50.0 M 34.0 20.0 L 50.0 0.0 L 66.0 20.0 M 26.0 30.0 L 10.0 50.0 L 42.0 50.0 M 74.0 30.0 L 90.0 50.0 L 58.0 50.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32,
			cy: 22.5,
			rx: .5,
			ry: .5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 30.1,
			cy: 25,
			rx: .5,
			ry: .5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.1,
			cy: 27.5,
			rx: .5,
			ry: .5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 68,
			cy: 22.5,
			rx: .5,
			ry: .5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 70,
			cy: 25,
			rx: .5,
			ry: .5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 72,
			cy: 27.5,
			rx: .5,
			ry: .5,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgOpenBulkStorage;
